module.exports = __webpack_public_path__ + "media/images/flags/CC-8c71571fcac564194f7215500803e7ef.svg";